"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["children", "className", "width", "dropMargins", "narrowYMargins", "dropYMargins", "dropMobileXMargins", "as"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { c as _c } from "react/compiler-runtime";
import { Box } from '@autoguru/overdrive';
import { invariant } from '@autoguru/utilities';
import * as styles from './ContainedLayout.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContainedLayout = t0 => {
  const $ = _c(35);
  let boxProps;
  let children;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      children,
      className: t1,
      width: t2,
      dropMargins: t3,
      narrowYMargins: t4,
      dropYMargins: t5,
      dropMobileXMargins: t6,
      as: t7
    } = _t);
    boxProps = _objectWithoutProperties(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = boxProps;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    boxProps = $[1];
    children = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
  }
  const className = t1 === undefined ? "" : t1;
  const width = t2 === undefined ? "medium" : t2;
  const dropMargins = t3 === undefined ? false : t3;
  const narrowYMargins = t4 === undefined ? false : t4;
  const dropYMargins = t5 === undefined ? false : t5;
  const dropMobileXMargins = t6 === undefined ? false : t6;
  const as = t7 === undefined ? "section" : t7;
  !!(dropYMargins && narrowYMargins) ? process.env.NODE_ENV !== "production" ? invariant(false, "Both dropYMargins & narrowYMargins cannot be true at the same time") : invariant(false) : void 0;
  const t8 = width === "narrow";
  const t9 = width === "wide";
  const t10 = width === "extra-wide";
  const t11 = width === "bleed";
  let t12;
  if ($[10] !== t10 || $[11] !== t11 || $[12] !== t8 || $[13] !== t9) {
    t12 = {
      [styles.narrow]: t8,
      [styles.wide]: t9,
      [styles.extraWide]: t10,
      [styles.bleed]: t11
    };
    $[10] = t10;
    $[11] = t11;
    $[12] = t8;
    $[13] = t9;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== className || $[16] !== t12) {
    t13 = [styles.root, className, t12];
    $[15] = className;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const t14 = !dropYMargins && !dropMargins;
  const t15 = !dropMobileXMargins && !dropMargins;
  let t16;
  if ($[18] !== dropMargins || $[19] !== dropMobileXMargins || $[20] !== dropYMargins || $[21] !== narrowYMargins || $[22] !== t14 || $[23] !== t15) {
    t16 = [styles.contents, {
      [styles.withYMargins]: t14,
      [styles.withoutYMargins]: dropYMargins,
      [styles.withNarrowYMargins]: narrowYMargins,
      [styles.withMobileXMargins]: t15,
      [styles.withoutMobileXMargins]: dropMobileXMargins,
      [styles.withoutMargins]: dropMargins
    }];
    $[18] = dropMargins;
    $[19] = dropMobileXMargins;
    $[20] = dropYMargins;
    $[21] = narrowYMargins;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== children) {
    t17 = /*#__PURE__*/_jsx(Box, {
      width: "full",
      className: styles.childHolder,
      children: children
    });
    $[25] = children;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t16 || $[28] !== t17) {
    t18 = /*#__PURE__*/_jsx(Box, {
      width: "full",
      className: t16,
      children: t17
    });
    $[27] = t16;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== as || $[31] !== boxProps || $[32] !== t13 || $[33] !== t18) {
    t19 = /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({}, boxProps), {}, {
      as: as,
      width: "full",
      className: t13,
      children: t18
    }));
    $[30] = as;
    $[31] = boxProps;
    $[32] = t13;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  return t19;
};